import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { RouteGuard } from '@core/components/navigation/RouteGuard';
import DashboardLayout from '@core/layouts/DashboardLayout';
import { ROUTES } from '@core/utils/constants';

const Settings = lazy(() => import('@settings/index'));

const SettingsRouter: RouteObject = {
  element: (
    <RouteGuard mode="protected">
      <DashboardLayout />
    </RouteGuard>
  ),
  children: [
    { path: ROUTES.app.settings, element: <Settings /> },
    { path: ROUTES.app.settingsTab, element: <Settings /> },
  ],
};

export default SettingsRouter;
